import {
  generateClassName,
  handleFieldBlur,
} from '@klv/shared/utils/functions';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import type { FocusEvent } from 'react';
import * as Yup from 'yup';
import { hasStorageAvailable } from '@klv/shared/utils/storage';
import { gtmFormEvent } from '@klv/shared/utils/google-tag-manager';
import RoundedText from '@klv/molecules/form-field/rounded-text';
import Button from '@klv/atoms/button';
import Buttons from '@klv/molecules/buttons';
import { Formik, Form } from 'formik';
import type { IFormValidationSchema, IInitialFormValues, ISingleLineFormState } from '../../organisms/form/types';
import type { ISingleLineForm } from './types';
import * as styles from './styles/singleLineForm.module.scss';
import { LIGHT_BACKGROUNDS } from '@klv/shared/utils/variables';
const initialValues: ISingleLineFormState = {
  email: '',
};
export const SingleLineForm = ({
  primaryButtonText,
  buttons = [],
  placeholderText,
  backgroundColor = 'dark',
}: ISingleLineForm) => {

  const { t } = useTranslation();
  const [formState, setFormState] = useState(initialValues);
  const [submitted, setSubmitted] = useState(false);

  const validationSchemaBase: IFormValidationSchema = {
    email: Yup.string()
      .email(`${t('atoms_singleLineForm_error')}`)
      .required(`${t('organisms_forms_fields_email_errors_required')}`),
  };

  const initialVals: IInitialFormValues = { email: formState.email };


  return (
    <div className={styles.singleLineFormContainer}>
      <Formik
        initialValues={initialVals}
        validationSchema={Yup.object(validationSchemaBase)}
        validateOnBlur={true}
        onSubmit={async (values) => {
          if (hasStorageAvailable('sessionStorage')) {
            sessionStorage.setItem('formValues', JSON.stringify({ email: values.email }));
          }
          window.location.assign('/sign-up');
          gtmFormEvent(values, 'singleLineForm', 'submit');
        }}
      >
        {(formik) => {
          const hasEmailError = submitted && formik.touched.email && formik.errors.email;

          return (
            <div
              className={generateClassName([
                styles.inputAndButtonContainer,
                hasEmailError && styles.errorBackground,
              ])}
            >
              <Form className={styles.formContainer} id="form--demoRequest">
                <RoundedText
                  backgroundColor={backgroundColor}
                  id="demoForm-email"
                  name="email"
                  type="email"
                  submitted={submitted}
                  placeholder={placeholderText || `${t('atoms_singleLineForm_placeholderText')}`}
                  onBlur={(event: FocusEvent) => handleFieldBlur(event, formik, setFormState, 'requestDemo')}
                />
                <Button
                  className={styles.getStartedButton}
                  text={primaryButtonText || `${t('atoms_singleLineForm_primaryButton')}`}
                  buttonColor='dark'
                  type="submit"
                  onFocus={() => {
                    setSubmitted(true);
                  }}
                />
              </Form>
            </div>
          );
        }}
      </Formik>

      <Buttons
        buttonColor='dark'
        variants={['tertiary', 'tertiary']}
        buttons={buttons} 
      />
    </div>
  );
};
